import { useDispatch, useSelector } from 'react-redux';
import { addStorefront, addStorefrontAbout, cachedDataPublish, updateStorefront, updateStorefrontAbout } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { 
    fetchStorefront, 
    fetchStorefrontAbout,
} from '../../../../Features/storefrontSlice';

function sortAboutData(data) {
    if(!data) {
        return [];
    }

    const typeOrder = ['ABOUT1', 'ABOUT2', 'ABOUT3', 'FEATURE1', 'FEATURE2'];
    const groupedData = new Map();

    typeOrder.forEach(type => {
        groupedData.set(type, []);
    });

    data.forEach(item => {
        if (groupedData.has(item.TypeData)) {
            groupedData.get(item.TypeData).push(item);
        }
    });

    const tempData = typeOrder.reduce((acc, type) => {
        const items = groupedData.get(type);
        return acc.concat(items);
    }, []);

    return tempData;
}

function CTAButtons() {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const { storefront } = useSelector((state) => state.storefront.storefront);
    const { storefrontAbout } = useSelector((state) => state.storefront.storefrontAbout);
    const pageType = useSelector((state) => state.storefront.pageType);

    function handlePreview() {
        // dispatch(openPreview(viewType));
    }

    async function handleSave() {
        if(pageType === 'STORE') {
            try {
                const callBody = {
                    logo: versionStack[versionIndex]?.logoImage,
                    publish: false,
                    save: true,
                    webBackgroundImage: versionStack[versionIndex].webBackgroundImage ? versionStack[versionIndex].webBackgroundImage : storefront?.webBackgroundImage,
                    BackGround: versionStack[versionIndex].backgroundImage ? versionStack[versionIndex].backgroundImage : storefront?.BackGround,
                    storeData: versionStack[versionIndex]?.versionData.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                    webStoreData: versionStack[versionIndex]?.webVersionData.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                }

                if(storefront && Object.keys(storefront).length > 0) {
                    const response = await updateStorefront(callBody);

                    if(response.status === 200) {
                        showToast('Storefront saved!', 'success');
                        return;
                    }
                }

                else {
                    if(versionStack[versionIndex]?.logoImage.length === 0) {
                        showToast('Add seller logo.', 'error');
                        return;
                    }
                    else if(versionStack[versionIndex]?.backgroundImage.length === 0 || versionStack[versionIndex]?.webBackgroundImage.length === 0) {
                        showToast('Add background image.', 'error');
                        return;
                    }
                    else {
                        const response = await addStorefront(callBody);

                        if(response.status === 200) {
                            showToast('Storefront saved!', 'success');
                            dispatch(fetchStorefront());
                        }
                    }
                }
            }
            catch(err) {
                showToast('Error saving storefront!', 'error');
            }
        }
        else {
            try {
                const callBody = {
                    publish: false,
                    save: true,
                    storeData: versionStack[versionIndex]?.storeAbout.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                    webStoreData: versionStack[versionIndex]?.webStoreAbout.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                }

                callBody.storeData = sortAboutData(callBody.storeData);
                callBody.webStoreData = sortAboutData(callBody.webStoreData);

                let response;
                if((storefrontAbout?.length > 0 || Object.keys(storefrontAbout).length > 0)) {
                    response = await updateStorefrontAbout(callBody);
                }
                else {
                    response = await addStorefrontAbout(callBody);
                }
                if(response.status === 200) {
                    showToast('Storefront saved!', 'success');
                    dispatch(fetchStorefrontAbout());
                }
            }
            catch(err) {
                showToast('Error saving storefront!', 'error');
            }
        }
    }

    async function handlePublish() {
        if(pageType === 'STORE') {
            try {
                const callBody = {
                    logo: versionStack[versionIndex]?.logoImage,
                    publish: true,
                    save: true,
                    webBackgroundImage: versionStack[versionIndex].webBackgroundImage ? versionStack[versionIndex].webBackgroundImage : storefront?.webBackgroundImage,
                    BackGround: versionStack[versionIndex].backgroundImage ? versionStack[versionIndex].backgroundImage : storefront?.BackGround,
                    storeData: versionStack[versionIndex]?.versionData.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                    webStoreData: versionStack[versionIndex]?.webVersionData.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                }

                if(storefront && Object.keys(storefront).length > 0) {
                    const response = await updateStorefront(callBody);

                    if(response.status === 200) {
                        await cachedDataPublish([`/v1/userstore/${storefront.id}`]);
                        showToast('Storefront published!', 'success');
                        return;
                    }
                }

                else {
                    if(versionStack[versionIndex]?.logoImage.length === 0) {
                        showToast('Add seller logo.', 'error');
                        return;
                    }
                    else if(versionStack[versionIndex]?.backgroundImage.length === 0 || versionStack[versionIndex]?.webBackgroundImage.length === 0) {
                        showToast('Add background image.', 'error');
                        return;
                    }
                    else {
                        const response = await addStorefront(callBody);

                        if(response.status === 200) {
                            await cachedDataPublish([`/v1/userstore/${storefront.id}`]);
                            showToast('Storefront published!', 'success');
                            dispatch(fetchStorefront());
                        }
                    }
                }
            }
            catch(err) {
                showToast('Error publishing storefront!', 'error');
            }
        }
        else {
            try {
                const callBody = {
                    publish: true,
                    save: true,
                    storeData: versionStack[versionIndex]?.storeAbout.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                    webStoreData: versionStack[versionIndex]?.webStoreAbout.map(item => {
                        const { id, ...rest } = item.item;
                        return rest;
                    }),
                }

                callBody.storeData = sortAboutData(callBody.storeData);
                callBody.webStoreData = sortAboutData(callBody.webStoreData);

                let response;
                if((storefrontAbout?.length > 0 || Object.keys(storefrontAbout).length > 0)) {
                    response = await updateStorefrontAbout(callBody);
                }
                else {
                    response = await addStorefrontAbout(callBody);
                }
                if(response.status === 200) {
                    await cachedDataPublish([`/v1/userstore/${storefront.id}`]);
                    showToast('Storefront publish!', 'success');
                    dispatch(fetchStorefrontAbout());
                }
            }
            catch(err) {
                showToast('Error publishing storefront!', 'error');
            }
        }
    }

    return (
        <div className="flex items-center gap-2">
            {/* <button onClick={handlePreview} className='outline-none px-4 py-[6px] font-semibold text-[12px] leading-6 text-[#1055EB]'>Preview &#40;Coming soon&#41;</button> */}

            <button onClick={handleSave} className='outline-none border border-[#999999] px-4 py-[6px] bg-[#FFFFFF] rounded-md font-semibold text-[12px] leading-6 text-[#121212]'>Save</button>

            <button onClick={handlePublish} className='outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Publish</button>
        </div>
    );
}

export default CTAButtons;
